import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import useTask from "../../hooks/useTask";

import DownloadPopup from "../../components/DownloadPopup";
import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import TaskAnswer from "../../components/taskAnswer";
const Task = () => {
  const location = useLocation();
  const {
    data,
    loading,
    questions,
    deleteLoading,
    fetchTaskById,
    performTask,
    getAnswer,
    setAnswer,
    onDelete,
    setAttachment,
    setComment,
    getComment,
    removeAtachment,
    setDescription,
    setEmails,
    getEmails
  } = useTask();
  const { isEmployee, isManager,user } = useAuth();
  const [task, setTask] = useState();
  const frequency = location?.search.split("?frequency=")[1];
  const disabled = false;
  const fresh = location.state?.fresh;
  const isRiskAssesment = location.state?.isRiskAssesment;
  const isAudit = location.state?.isAudit;

  useEffect(() => {
    fetchTaskById(location.state?._id, { fresh, isRiskAssesment, isAudit });
  }, []);

  return (
    <Screen
      flow={
        location.state?.notification || fresh
          ? [{ label: !data ? "" : `${data?.title}` }]
          : [
            { label: `${location?.state?.title}` },
            { label: "Home", to: "/" },
            {
              label: `${frequency}`,
              to: `/tasks${location?.search}`,
              state: location?.state,
            },
            {
              label: "Task",
            },
          ]
      }
    >
      <div className="d-flex flex-column align-items-end" id="parentTask">
        {(isEmployee && !isManager) || fresh ? null : (
          <div className="row d-flex justify-content-end mb-2">
            <SubmitButton
              icon={<i className="bi bi-trash3"></i>}
              loading={deleteLoading}
              onClick={() => onDelete(location.state?._id)}
              color={"danger"}
              loaderColor={"white"}
            />
          </div>
        )}
        <div className="row d-flex justify-content-evenly w-100" id="capture">
          {questions?.map((item, index) => {
            const isBoolean = item.type == "boolean";
            return (
              <TaskAnswer
                key={index}
                item={item}
                isBoolean={isBoolean}
                getAnswer={getAnswer}
                setAnswer={setAnswer}
                setEmails={setEmails}
                getEmails={getEmails}
                setDescription={setDescription}
                disabled={disabled}
                setComment={setComment}
                setAttachment={setAttachment}
                data={data}
                getComment={getComment}
                removeAtachment={removeAtachment}
                user={user}
              />
            );
          })}
        </div>
        {disabled ? (
          <button
            onClick={() => setTask(location?.state)}
            className="btn btn-primary"
          >
            {loading ? "Loading document..." : "Download now!"}
          </button>
        ) : (
          <SubmitButton
            title={
              data?.status == "Approved" ? "Update Answers" : "Submit Answers"
            }
            color={"primary"}
            loading={loading}
            onClick={() => performTask(fresh, isRiskAssesment, isAudit)}
            loaderColor={"white"}
          />
        )}
      </div>
      <DownloadPopup task={task} handleClose={() => setTask(undefined)} isRiskAssesment={isRiskAssesment} />
    </Screen>
  );
};

export default Task;
